<template>
    <div class="page">
        <div class="screenLine">
            <el-input @keyup.enter.native="handelComClick" v-model="keyword" placeholder="用户"
                style="width: 240px; margin-right: 16px"></el-input>
            <div>申请状态：</div>
            <el-select v-model="state" placeholder="申请状态" class="titleSelect" @change="handelComClick">
                <el-option v-for="item in stateList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <div>申请日期：</div>
            <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" style="margin-right:16px" @change="handelComClick">
            </el-date-picker>
            <el-button type="warning" plain @click="handleResetClick">重置</el-button>
        </div>
        <div class="tableBox">
            <el-table :data="tableData" style="width: 100%;height: 100%;">
                <el-table-column prop="no" label="退单编号">
                </el-table-column>
                <el-table-column prop="order_id" label="订单编号">
                </el-table-column>

                <el-table-column prop="user_info.nick_name" label="用户">
                </el-table-column>
                <el-table-column prop="user_info.user_mobile" label="电话">
                </el-table-column>
                <el-table-column label="申请日期">
                    <template slot-scope="scope">{{ $public.FTime(scope.row.create_time, "YYYY-MM-DD HH:mm:ss")
                    }}</template>
                </el-table-column>
                <el-table-column  label="退货原因">
                    <template slot-scope="scope">{{scope.row.refund_reason ==null? '--':scope.row.refund_reason.refund_reason_detail}}
                </template>
                </el-table-column>
                <el-table-column label="申请状态状态">
                    <template slot-scope="scope">{{ $public.formatOrderReturnState(scope.row.state)}}</template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleSeeClick(scope.row)">查看</el-button>
                    </template>
                </el-table-column>

            </el-table>
           
        </div>
        <page :page="page.page" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>
    </div>
</template>
    
<script>
import page from "../../../../components/page.vue"
export default {
    components: {
        page,
    },
    data() {
        return {
            page: {
                page: 1,
                pageSize: 10,
                total: 0
            },
            type: '',
            date: '',//日期
            state: '-1',
            keyword: "", //关键字
            tableData: [], //订单列表
            stateList: [{ label: '已取消', value: '-2' }, { label: '全部', value: '-1' }, { label: '已删除', value: '0' }, { label: '已申请', value: '1' }, { label: '已审核', value: '2' }, { label: '退换中', value: '3' }, { label: '物流中', value: '4'}, { label: '退换成功', value: '8' }],

        }
    },
    mounted() {
        this.getTableData()

    },
    methods: {
        // 查看
        handleSeeClick(row) {
            let query = {
                id: row._id,
            }
            this.$router.push({ path: '/onlineReturn/onlineReturnSee', query })
        },
       
        getTableData() {
            let params = {
                page_index: this.page.page,
                page_size: this.page.pageSize,
                keyword: this.keyword,
                state: this.state, // 状态 -2 已取消 0 已删除 1 已申请 2 已审核 3 退款中 4 物流中 5退款成功
                shop_id: this.$store.state.shopId,
                source: '1',
                return_type: '1',
            }
            if (this.date != '') {
                params.starttime = this.$public.FTimeStr10(this.date[0]);
                params.endtime = this.$public.FTimeStr10(this.date[1]);
            }
            this.$http.post(process.env.VUE_APP_Url_order + '/api/OffLineOrderReturn/list', params).then((res) => {
                if (res.code == 0) {
                    this.tableData = res.data.data;
                    this.page.total = res.data.count;

                }
            })
        },
        // 搜索
        handelComClick() {
            this.page.page = 1;
            this.getTableData()
        },
        //重置
        handleResetClick() {
            this.page.page = 1;
            this.keyword = "";
            this.state = '-1';
            this.getTableData()
        },
        // 分页方法
        changePage(num) {
            this.page.page = num;
            this.getTableData();
        },
    }
}
</script>
    
<style lang="scss" scoped>
.page {
    padding: 16px 16px 65px 16px;
    height: 100%;
    box-sizing: border-box;
    position: relative;

    .screenLine {
        display: flex;
        align-items: center;

        .titleSelect {
            width: 130px;
            margin-right: 16px;
        }
    }

    .tableBox {
        padding: 16px;
        border-radius: 8px;
        background-color: #fff;
        box-sizing: border-box;
        margin-top: 16px;
        height: calc(100% - 56px);
    }
}
</style>